// import notificationSound from 'static/sounds/notification.wav'
import {
  wsAppendCommonNotification,
  wsAppendNotification,
  wsAppendRequest
} from './actions'
import { setSnackbar } from 'utils/common/actions'
import Config from 'config'
import store from 'store'

const { wsUrl } = Config.network
let ws = null
let tryReconnect = true

export function closeWebsocketConnection() {
  if (ws) {
    tryReconnect = false
    ws.close()
    ws = null
  }
}

export default function notificationsConnection() {
  return function action(dispatch) {
    let wsClose
    let connectionAttempts = 0
    // const notificationAudio = new Audio(notificationSound)
    tryReconnect = true

    // notificationAudio.load()
    // notificationAudio.type = ' audio/wav'

    // function playAudio(audio) {
    //   const playPromise = audio.play()
    //   if (typeof playPromise !== 'undefined') {
    //     playPromise.then(function () {
    //     }).catch(function (error) {
    //       console.log(error)
    //     })
    //   }
    // }

    function wsOpen() {
      console.log('Connected to WebSocket server')
    }

    function wsError() {
    }

    function wsMessage(event) {
      const parsed = JSON.parse(event.data)
      if (parsed.type === 'request.send') {
        dispatch(wsAppendRequest(parsed.payload))
      } else if (parsed.type === 'notification.send') {
        dispatch(wsAppendNotification(parsed.payload))
      } else if (parsed.type === 'common.notification.send') {
        dispatch(wsAppendCommonNotification(parsed.payload))
      }
    }

    function connect() {
      const endpoint = `${wsUrl}/notifications/`
      const authHeader = 'Token'
      const { authToken } = store.getState().auth
      if (authToken) {
        ws = new WebSocket(endpoint, [authHeader, authToken])
        ws.onmessage = wsMessage
        ws.onopen = wsOpen
        ws.onerror = wsError
        ws.onclose = wsClose
        connectionAttempts = 0
        dispatch(setSnackbar(null))
      }
    }

    wsClose = function close() {
      const { authToken } = store.getState().auth
      if (!authToken ||  authToken === 'null') {
        return null
      }
      connectionAttempts = connectionAttempts + 1
      if (connectionAttempts < 3 && tryReconnect) {
        console.log('Connection closed. Try to reconnect in 3 sec...')
      }
      if (connectionAttempts === 3) {
        dispatch(setSnackbar('WebSocket connectin error. Please reload the page', 'error'))
      }
      setTimeout(() => {
        connect()
      }, 3000)
    }

    connect()
  }
}
